<!-- src/views/contact/staff/AllChildren.vue -->
<template>
  <div>
    <!-- 查询区域 -->
    <el-form
      :model="queryParams"
      label-position="right"
      label-width="50px"
      style="margin-bottom: 20px"
    >
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="年级">
            <el-select
              v-model="queryParams.gradeId"
              placeholder="请选择年级"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="grade in gradeOptions"
                :key="grade.id"
                :label="grade.name"
                :value="grade.id"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="班级">
            <el-select
              v-model="queryParams.classId"
              placeholder="请选择班级"
              clearable
              style="width: 100%"
              :disabled="!queryParams.gradeId"
            >
              <el-option
                v-for="classItem in classOptions"
                :key="classItem.id"
                :label="classItem.name"
                :value="classItem.id"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="姓名">
            <el-input
              v-model="queryParams.name"
              placeholder="请输入姓名"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <div>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery(1)">
          搜索
        </el-button>
        <el-button @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">
          新增
        </el-button>
      </div>
    </el-form>

    <!-- 表格区域 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{
        background: '#f5f7fa',
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
      }"
    >
      <el-table-column label="姓名" prop="name" />
      <el-table-column label="性别">
        <template slot-scope="scope">
          {{ scope.row.sex === 1 ? "男" : "女" }}
        </template>
      </el-table-column>
      <el-table-column label="生日" prop="birthday" />
      <el-table-column label="班级" prop="clazzName" />
      <el-table-column label="状态">
        <template slot-scope="scope">
          {{
            scope.row.state === 1
              ? "在读"
              : scope.row.state === 2
              ? "已退学"
              : "毕业"
          }}
        </template>
      </el-table-column>
      <el-table-column label="IC卡号" prop="cardNo" />
      <el-table-column label="创建时间" width="200" prop="createTime" />
      <el-table-column label="操作" width="250">
        <template v-slot="scope">
          <el-button
            type="primary"
            size="mini"
            @click="openEditDialog(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="warning"
            size="mini"
            @click="unbind(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <pagination-bar
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @update:pageSize="pageSize = $event"
      @update:currentPage="currentPage = $event"
      @page-change="handleQuery"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      @close="resetForm"
      class="custom-dialog"
      :visible.sync="dialogVisible"
      :title="isEdit ? '编辑儿童信息' : '新增儿童信息'"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="formData" ref="form" :rules="rules" label-width="120px">
        <el-form-item label="姓名" prop="name">
          <el-input
            v-model="formData.name"
            placeholder="请输入姓名"
            style="width: 350px"
          />
        </el-form-item>

        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="formData.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="出生日期" prop="birthday">
          <el-date-picker
            v-model="formData.birthday"
            type="date"
            placeholder="选择出生日期"
            style="width: 350px"
          />
        </el-form-item>

        <el-form-item label="年级" prop="gradeId">
          <el-select
            v-model="formData.gradeId"
            placeholder="请选择年级"
            style="width: 350px"
          >
            <el-option
              v-for="grade in gradeOptions"
              :key="grade.id"
              :label="grade.name"
              :value="grade.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="班级" prop="classId">
          <el-select
            v-model="formData.classId"
            placeholder="请选择班级"
            style="width: 350px"
            :disabled="!formData.gradeId"
          >
            <el-option
              v-for="classItem in classOptionsForForm"
              :key="classItem.id || classItem.name"
              :label="classItem.name"
              :value="classItem.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="IC卡号" prop="cardNo">
          <el-select
            v-model="formData.cardNo"
            placeholder="请选择IC卡号"
            style="width: 350px"
            filterable
            clearable
          >
            <el-option
              v-for="card in cardOptions"
              :key="card.id"
              :label="card.cardNo"
              :value="card.cardNo"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { gradeAll, getAllClazzList } from "@/api/repair";
import {
  childrenList,
  childAddOrEdit,
  childDelete,
  childrenQuit,
  cardPage,
} from "@/api/staff.js";
import { formatTime } from "@/utils/util";
import PaginationBar from "@/components/PaginationBar";

export default {
  components: {
    PaginationBar,
  },
  data() {
    return {
      cardOptions: [], // mac列表
      dialogVisible: false,
      isEdit: false,
      classOptionsForForm: [],
      formData: {
        name: "",
        sex: 1,
        birthday: "",
        gradeId: "",
        classId: "",
        cardNo: "", // 将 mac 改为 cardNo
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        birthday: [
          { required: true, message: "请选择出生日期", trigger: "change" },
        ],
        gradeId: [{ required: true, message: "请选择年级", trigger: "change" }],
        classId: [{ required: true, message: "请选择班级", trigger: "change" }],
        cardNo: [
          { required: false, message: "请选择IC卡号", trigger: "change" },
        ], // 将 mac 改为 cardNo
      },
      positionOptions: [],
      gradeOptions: [],
      classOptions: [],
      queryParams: {
        gradeId: "",
        classId: "",
        name: "",
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
    };
  },
  created() {
    this.handleQuery();
    //获取所有年级
    this.getAllGrade();
    // 获取所有的mac卡列表
    this.getCardList();
  },
  watch: {
    "queryParams.gradeId": {
      handler(newVal) {
        if (newVal) {
          this.getClassListByGrade(newVal);
        } else {
          this.classOptions = [];
          this.queryParams.classId = "";
        }
      },
    },
    "formData.gradeId": {
      handler(newVal) {
        if (newVal) {
          this.getClassListByGrade(newVal);
        } else {
          this.classOptionsForForm = [];
          this.formData.classId = "";
        }
      },
    },
  },
  methods: {
    // 请求所有的卡
    getCardList() {
      cardPage({
        pageNo: 1,
        pageSize: 1000,
        state: 0, // 查询未使用的
      }).then((res) => {
        console.log(res);
        this.cardOptions = res.records || [];
      });
    },
    dropout(row) {
      // 检查学生是否已经退学
      if (row.state === 2) {
        this.$message.warning("该学生已经退学");
        return;
      }
      this.$confirm(`确认退学${row.name}吗?`, "退学确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          childrenQuit({ id: row.id }).then(() => {
            this.$message.success("退学操作成功！");
            this.handleQuery(this.currentPage);
          });
        })
        .catch(() => {});
    },
    getAllGrade() {
      gradeAll().then((res) => {
        this.gradeOptions = res || [];
      });
    },
    getClassListByGrade(gradeId) {
      getAllClazzList({ gradeId }).then((res) => {
        this.classOptionsForForm = this.classOptions = res || [];
        this.queryParams.classId = "";
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.formData = {
        name: "",
        sex: 1,
        birthday: "",
        gradeId: "",
        classId: "",
        cardNo: "", // 将 mac 改为 cardNo
      };
      this.classOptionsForForm = [];
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
      };
      childrenList(params)
        .then((res) => {
          this.total = res.total;
          this.tableData = res.records;
        })
        .catch((err) => {
          console.error("请求失败：", err);
        });
    },
    resetQuery() {
      this.queryParams = {
        gradeId: "",
        classId: "",
        name: "",
      };
      this.classOptions = [];
      this.currentPage = 1;
      this.handleQuery();
    },
    openAddDialog() {
      this.isEdit = false;
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true;
      this.formData = {
        id: row.id,
        name: row.name,
        sex: row.sex,
        birthday: row.birthday ? new Date(row.birthday) : "",
        gradeId: row.gradeId,
        classId: row.clazzId,
        cardNo: row.cardNo,
      };
      this.dialogVisible = true;
    },
    // 修改 unbind 方法
    unbind(row) {
      this.$confirm(`确认删除学生 ${row.name} 吗？`, "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          childDelete({ id: row.id })
            .then(() => {
              this.$message.success(`删除成功：${row.name}`);
              this.handleQuery();
            })
            .catch(() => {
              this.$message.error("删除失败");
            });
        })
        .catch(() => {
          // 用户取消操作
        });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { birthday } = this.formData;
          const params = { ...this.formData };
          params.birthday = birthday ? formatTime(birthday) : "";
          params.clazzId = params.classId; // 处理错误参数
          childAddOrEdit(params)
            .then(() => {
              this.$message.success("操作成功");
              this.dialogVisible = false;
              this.handleQuery();
            })
            .catch((error) => {
              this.$message.error(error);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>

<style scoped>
.custom-dialog >>> .el-dialog {
  margin-top: 20px !important;
  max-height: 90vh;
  overflow-y: auto;
}
</style>
